/* global Backbone */
'use strict';

import loader from 'helpers/loader';
import tooltip from 'helpers/tooltip';
import template from '../../templates/timesheet/timesheetUpload/Main.ejs';
import jobStatusTemplate from
    '../../templates/timesheet/timesheetUpload/JobStatus.ejs';
import Alerts from 'lib/alerts';
import BulkUpload from 'newModels/bulk-upload.js';

module.exports = Backbone.View.extend({
    events: {
        'change input[type="file"]': 'selectFile',
        'click .js-action-1': 'uploadFile'
    },

    render: function() {
        this.$el.html(template({
            model: this.model || false,
        }));

        this.$('.js-action-1').prop('disabled', true);

        tooltip.init(this);

        if (this.model && this.model.get('state') !== 'done') {
            this.renderJobStatus();
        }
        return this;
    },

    selectFile: function(e) {
        const files = [...this.$(e.currentTarget)[0].files];

        if (files.length === 0) {
            return;
        }

        const file = files.shift();
        const ext = file.name.split('.').pop();

        if (!ext.match(/^(xls|xlsx)$/i)) {
            return Alerts.show('error', {
                title: 'Wrong file type',
                text: 'Please choose an Excel file'
            });
        }

        this.$('.js-action-1').prop('disabled', false);
        this._file = file;
        this.$('.js-file-name').text(this._file.name);
        if (this.$result) {
            this.$result.fadeOut(50, () => {
                this.$('.js-result').html('');
            });
        }
    },

    uploadFile: function() {
        this.$('.js-file-btn').prop('disabled', true);

        const stopLoader = loader.startFullScreen(this.$('.js-action-1'));
        const file = this._file;
        const originalName = file.name;
        const ext = originalName.split('.').pop();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = ev => {
                const base64 = ev.target.result.split(',')[1];
                this.model = new BulkUpload({
                    type: 'timesheet',
                    file: {
                        name: `spreadsheet.${ext}`,
                        content: base64
                    },
                    companyId: app.company.id
                });
                return resolve(true);
            };
            reader.onerror = err => reject(err);
            reader.readAsDataURL(file);
        }).then(
            () => this.model.save()
        ).then(() => {
            this.render();
        }).finally(stopLoader);
    },

    renderJobStatus: function() {
        if (!this.model) {
            this.$('.js-status').html('');
            return;
        }

        this.$('.js-status').html(jobStatusTemplate({
            model: this.model
        }));

        const refresh = () => {
            if (!this.model || this.model.get('state') === 'done') {
                this.render();
                this.$('.js-status').html(jobStatusTemplate({
                    model: this.model
                }));
                return;
            }

            setTimeout(() => {
                this.model.fetch().then(() => {
                    this.$('.js-status').html(jobStatusTemplate({
                        model: this.model
                    }));
                    refresh();
                });
            }, 2000);
        };
        refresh();
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/timesheet/TimesheetUpload.js